import { Link } from "react-router-dom";

export const Logo = ({ dark = false, className = "h-9" }) => (
  <Link to="/" data-testid="logo-link" aria-label="Digital AdDoctor home" className="inline-flex items-center">
    <img src={dark ? "/img/logo-dark.png" : "/img/logo-light.png"} alt="Digital AdDoctor" className={`${className} w-auto transition-[height] duration-500`} width="314" height="187" />
  </Link>
);
